import { render, staticRenderFns } from "./alarmBridgeBosch.vue?vue&type=template&id=0387d7fe&scoped=true"
import script from "./alarmBridgeBosch.vue?vue&type=script&lang=js"
export * from "./alarmBridgeBosch.vue?vue&type=script&lang=js"
import style0 from "./alarmBridgeBosch.vue?vue&type=style&index=0&id=0387d7fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387d7fe",
  null
  
)

export default component.exports